import { render } from "./AthleteTrainingPanel.vue?vue&type=template&id=287f9f8f&scoped=true"
import script from "./AthleteTrainingPanel.vue?vue&type=script&lang=js"
export * from "./AthleteTrainingPanel.vue?vue&type=script&lang=js"

import "./AthleteTrainingPanel.vue?vue&type=style&index=0&id=287f9f8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287f9f8f"]])

export default __exports__